import { IEmployeeGradeState } from "../types";

const state: IEmployeeGradeState = {
  employeeGrades: [],
  isFetchingEmployeeGrades: false,
  employeeGradeActionLoading: false,
};

export default state;
